import { Link } from "gatsby";
import React from "react";
import { useState } from "react";

import styled from "styled-components";


const Wrapper = styled.div`
	position: fixed;
	z-index: 9;

	@media (max-width: 1140px) {
		background: white;
		width: 100%;
		z-index: 10;
	}
`

const Nav = styled.nav`
	background: white;
	display: flex;
	padding: 20px 0px 20px 20px;
	box-sizing: border-box;
	transform: ${(props) => (props.sidebar ? 'translateX(0)' : 'translateX(-100%)')};
	transition: 0.3s ease;
	align-items: top;
	vertical-align: text-top;
	z-index: 1;
	top: 0;
	left: ${(props) => (props.sidebar ? '0px' : '50px')};
	position: fixed;

`;

const NavBrand = styled(Link)`
	display: block;
	flex-grow: 1;
	font-weight: 700;
	color: #333;
	width: 120px;
	padding: 20px;
	text-decoration: none;
	svg {
		height: auto;
		width 80px;
	}
`;

const NavItems = styled.ul`
	position: fixed;
	box-sizing: border-box;
	display: flex;
	padding: 20px;
	transform: rotate(90deg);
	transform-origin: 0% 100%;
	@media (max-width: 1140px) {
		transform: rotate(0deg);
		margin-left: 100px;
	}
`;

const NavItem = styled(Link)`
	font-family: serif;
	font-size: 22px;
	color: black;
	margin-left: 20px;
	text-decoration: underline;

	&:hover {
		text-decoration: none;
	}
`;

/*
const NavItemButton = styled.button`
	background none;
	appearance: none;
	border: none;
	height: 40px;
	margin-top: 30px;
	left: 0;
	top: 2rem;
	cursor: pointer;
	transform: rotate(90deg);
`;
*/

const Header = ({ onHideNav, onShowNav, showNav, siteTitle }) => {
	if (typeof window !== `undefined`) {
	var USEREMAIL = window.localStorage.getItem("email");
	}
	
	return(
	<Wrapper>
		<NavBrand to="/projects">
			<svg width="63" height="44" viewBox="0 0 63 44" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0)"> <path d="M23.0994 10.9996C22.3994 11.4996 21.9994 12.1996 21.8994 12.8996C21.7994 13.7996 22.3994 14.5996 23.6994 15.2996C24.1994 15.4996 24.6994 15.7996 25.2994 15.9996C25.8994 16.1996 26.6994 16.3996 27.7994 16.5996C27.2994 18.1996 27.2994 19.3996 27.6994 20.1996C28.0994 21.0996 28.6994 21.6996 29.5994 22.1996C30.4994 22.6996 31.5994 22.8996 32.7994 22.7996C33.9994 22.6996 35.0994 22.2996 36.0994 21.5996C36.7994 21.0996 37.1994 20.5996 37.4994 19.9996C37.7994 19.3996 37.8994 18.5996 37.7994 17.5996C39.1994 17.5996 40.2994 17.4996 41.0994 17.2996C41.8994 17.0996 42.5994 16.7996 43.0994 16.4996C43.7994 15.9996 44.0994 15.4996 44.0994 14.8996C44.0994 14.2996 43.6994 13.5996 42.7994 12.8996L42.1994 12.9996C42.5994 13.3996 42.7994 13.6996 42.7994 14.0996C42.7994 14.4996 42.5994 14.7996 42.1994 15.0996C41.7994 15.3996 41.1994 15.5996 40.4994 15.7996C39.7994 15.8996 38.7994 15.9996 37.4994 15.9996C37.0994 14.9996 36.5994 13.9996 35.9994 12.8996C35.2994 11.8996 34.9994 11.1996 34.9994 10.8996C34.9994 10.5996 35.2994 10.1996 35.6994 9.79961L35.2994 9.59961L31.5994 12.2996L31.9994 12.4996C32.2994 12.2996 32.5994 12.2996 32.8994 12.2996C33.2994 12.2996 33.6994 12.3996 34.0994 12.5996C35.1994 13.1996 35.9994 14.2996 36.4994 15.8996C34.2994 15.7996 31.9994 15.4996 29.4994 15.1996C29.8994 13.9996 29.9994 13.0996 29.7994 12.4996C29.5994 11.8996 29.1994 11.2996 28.3994 10.8996C27.5994 10.4996 26.7994 10.2996 25.7994 10.3996C24.6994 10.1996 23.7994 10.4996 23.0994 10.9996ZM28.2994 14.7996C27.0994 14.4996 26.2994 14.2996 25.6994 14.1996C25.1994 13.9996 24.6994 13.8996 24.2994 13.6996C23.8994 13.4996 23.5994 13.0996 23.3994 12.6996C23.1994 12.2996 23.3994 11.8996 23.8994 11.4996C24.2994 11.1996 24.7994 11.0996 25.3994 11.0996C25.9994 11.0996 26.5994 11.1996 27.0994 11.4996C27.7994 11.8996 28.1994 12.2996 28.3994 12.8996C28.6994 13.3996 28.5994 13.9996 28.2994 14.7996ZM35.5994 20.0996C34.8994 20.5996 33.9994 20.8996 32.9994 20.7996C31.9994 20.7996 31.0994 20.5996 30.2994 20.0996C29.5994 19.6996 29.0994 19.1996 28.7994 18.5996C28.4994 17.9996 28.4994 17.2996 28.6994 16.4996C29.9994 16.6996 31.0994 16.8996 31.9994 16.9996C32.8994 17.0996 34.3994 17.1996 36.5994 17.3996C36.5994 18.1996 36.4994 18.6996 36.3994 19.0996C36.2994 19.5996 35.9994 19.8996 35.5994 20.0996Z" fill="black"/> <path d="M0.199609 26.2V14.7L38.8996 32.3V43.8L0.199609 26.2ZM0.0996094 14.5V26.2L0.199609 26.3L38.9996 44H39.0996V43.9V32.2L38.9996 32.1L0.0996094 14.5Z" fill="#241F21"/> <path d="M62.9002 17.558L38.9434 32.0508L39.0469 32.2219L63.0037 17.7291L62.9002 17.558Z" fill="#241F21"/> <path d="M62.9428 29.3277L39 43.8457L39.1037 44.0167L63.0465 29.4987L62.9428 29.3277Z" fill="#241F21"/> <path d="M0.0995226 14.6L24.0995 0.2L62.8995 17.8H62.9995V17.7L24.0995 0H23.9995L-0.000477429 14.4C-0.000477429 14.4 -0.100477 14.5 -0.000477429 14.5C-0.000477429 14.6 0.0995226 14.6 0.0995226 14.6Z" fill="#241F21"/> <path d="M62.8996 18.9004L39.0996 33.3004V33.4004L62.8996 18.9004Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 33.3998H39.1V33.2998L39 33.3998Z" fill="#241F21"/> <path d="M62.8996 18.2998L39.0996 32.6998V32.7998L62.8996 18.3998V18.2998Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 32.8002H39.1V32.7002L39 32.8002Z" fill="#241F21"/> <path d="M62.8996 19.5L39.0996 33.9V34L62.8996 19.5Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 34.0004H39.1V33.9004L39 34.0004Z" fill="#241F21"/> <path d="M62.8996 20.0996L39.0996 34.4996V34.5996L62.8996 20.0996Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 34.6H39.1V34.5L39 34.6Z" fill="#241F21"/> <path d="M62.8996 20.7002L39.0996 35.1002V35.2002L62.8996 20.7002Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 35.1996H39.1V35.0996L39 35.1996Z" fill="#241F21"/> <path d="M62.8996 21.2998L39.0996 35.6998V35.7998L62.8996 21.2998Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 35.8002H39.1V35.7002L39 35.8002Z" fill="#241F21"/> <path d="M62.8996 21.9004L39.0996 36.3004V36.4004L62.8996 21.9004Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 36.3998H39.1V36.2998L39 36.3998Z" fill="#241F21"/> <path d="M62.8996 22.5L39.0996 36.9V37L62.8996 22.5Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 37.0004H39.1V36.9004L39 37.0004Z" fill="#241F21"/> <path d="M62.8996 23.0996L39.0996 37.4996V37.5996L62.8996 23.0996Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 37.6H39.1V37.5L39 37.6Z" fill="#241F21"/> <path d="M62.8996 23.7002L39.0996 38.1002L62.8996 23.7002Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 38.1996H39.1V38.0996L39 38.1996Z" fill="#241F21"/> <path d="M62.8996 24.2998L39.0996 38.6998L62.8996 24.2998Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 38.8002L39.1 38.7002L39 38.8002Z" fill="#241F21"/> <path d="M62.8996 24.9004L39.0996 39.3004L62.8996 24.9004Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 39.3998L39.1 39.2998L39 39.3998Z" fill="#241F21"/> <path d="M62.8996 25.5L39.0996 39.9L62.8996 25.5Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 39.9004V40.0004L39.1 39.9004H39Z" fill="#241F21"/> <path d="M62.8996 26.0996L39.0996 40.4996L62.8996 26.0996Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 40.5V40.6L39.1 40.5H39Z" fill="#241F21"/> <path d="M62.8996 26.7002L39.0996 41.1002L62.8996 26.7002Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 41.0996V41.1996L39.1 41.0996H39Z" fill="#241F21"/> <path d="M62.8996 27.2998L39.0996 41.6998L62.8996 27.2998Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 41.7002V41.8002L39.1 41.7002H39Z" fill="#241F21"/> <path d="M62.8996 27.9004L39.0996 42.3004L62.8996 27.9004Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 42.2998V42.3998L39.1 42.2998H39Z" fill="#241F21"/> <path d="M39.0996 42.9004L62.8996 28.5004V28.4004L39.0996 42.9004Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M39 42.9004V43.0004L39.1 42.9004H39Z" fill="#241F21"/> <path d="M39.0996 43.5L62.8996 29.1V29L39.0996 43.5Z" stroke="#4F4D4D" stroke-width="0.05" stroke-miterlimit="10"/> <path d="M38.9004 23.5V23.6L39.0004 23.5H38.9004Z" fill="#241F21"/> </g> <defs> <clipPath id="clip0"> <rect width="63" height="44" fill="white"/> </clipPath> </defs> </svg>
		</NavBrand>

		<Nav sidebar={true}>
			<NavItems onClick={onHideNav}>
				<NavItem to="/projects">Home</NavItem>
				<NavItem to="/profiles/">Index</NavItem>
				
				{/* Steve add login link below */}
				{USEREMAIL ? <NavItem to="/selfprofile/">Profile</NavItem> : <NavItem to="/login/">Login</NavItem>}
				{USEREMAIL ? <NavItem to="/login/" onClick={()=>{window.localStorage.removeItem("email")}}>Logout</NavItem> : ""}
				
				{false && <NavItem to="/search/">Search</NavItem>}
			</NavItems>
		</Nav>
	</Wrapper>)
};

export default Header;
